import * as React from 'react'
import cls from './HostPortalStatCard.module.scss'

const HostPortalStatCard = ({ statTitle, statValue }) => (
  <div className={cls.statContainer}>
    <p className={cls.statTitle}>{statTitle}</p>
    <h1 className={cls.statContent}>{statValue}</h1>
  </div>
)

export default HostPortalStatCard
